import { HttpClient } from "@angular/common/http";
import { environment } from "#environments/environment";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ChatbotResponse } from "#models/chatMessage.model";

@Injectable()
export class AIChatbotService {
  constructor(private http: HttpClient) {}

  askAIChatbot(question: string): Observable<ChatbotResponse> {
    return this.http.post<ChatbotResponse>(
      `${environment.apiEndpoint}/worklist-items/ai-chatbot`,
      {
        question,
      }
    );
  }
}
